import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { DirtyErrorStateMatcher } from '@services/forms/dirty-error-state-matcher';

import { SharedModule } from '@app/shared/shared.module';
import { ManagerComponent } from './manager.component';
import { ManagerRoutingModule } from './manager.routing';
import { AccountSettingsModule, ApiDocumentationModule, CompanyModule, RegistrationsModule, UsersModule } from './modules';

const allComponents = [ManagerComponent];

@NgModule({
	declarations: [...allComponents],
	imports: [
		ManagerRoutingModule,
		SharedModule,
		UsersModule,
		RegistrationsModule,
		ApiDocumentationModule,
		AccountSettingsModule,
		CompanyModule
	],
	exports: [CommonModule, ManagerRoutingModule],
	providers: [{ provide: ErrorStateMatcher, useClass: DirtyErrorStateMatcher }]
})
export class ManagerModule {}
